﻿(function (angular) {
  "use strict";

  var defaultMedia = {
    $el: angular.element("body"),
    pseudoEl: "before",
    mediaProperty: "viewportWidth",
    mediaRegexes: {
      xxxs: "^xxxs$",
      xxs: "^xxs$",
      xs: "^xs$",
      sm: "^sm$",
      md: "^md$",
      lg: "^lg$",
    },
  };

  angular.module("Toyota.Factories").factory("CssMediaWatcher", function () {
    function getPseudoElementContent($el, pseudoEl) {
      if (!$el.length) {
        throw new Error("No elements passed in jQuery object");
      }

      var content = window.getComputedStyle($el.get(0), pseudoEl).getPropertyValue("content");
      var regexpIsQuoted = /"(.*?)"/;
      return regexpIsQuoted.test(content) ? content.match(regexpIsQuoted)[1] : content;
    }

    function getCurrentMediaFromElement($el, pseudoEl, pseudoElRegexesByMediaName) {
      var currentPseudoElContent = getPseudoElementContent($el, "::" + pseudoEl);
      var isMediaActiveMap = {};
      var currentBreakpointName = null;

      /*
       * Build an object with one bool per media name, so that CssMediaWatcher
       * event consumers can ask if "data.viewportWidth.is.xs"
       */
      for (var mediaName in pseudoElRegexesByMediaName) {
        if (Object.prototype.hasOwnProperty.call(pseudoElRegexesByMediaName, mediaName)) {
          var mediaIsActive = new RegExp(pseudoElRegexesByMediaName[mediaName]).test(currentPseudoElContent);
          isMediaActiveMap[mediaName] = mediaIsActive;
          if (mediaIsActive) {
            currentBreakpointName = mediaName;
          }
        }
      }

      return {
        breakpoint: currentBreakpointName,
        is: isMediaActiveMap,
      };
    }

    return function (overrides) {
      var api = {};
      var currentMedia;
      var oldCurrentMedia;
      var inited;
      var config;

      function triggerEventIfMediaChanged() {
        currentMedia = config.media.reduce(function (currentMedia, media) {
          currentMedia[media.mediaProperty] = getCurrentMediaFromElement(media.$el, media.pseudoEl, media.mediaRegexes);
          return currentMedia;
        }, {});
        if (JSON.stringify(oldCurrentMedia) !== JSON.stringify(currentMedia)) {
          config.$eventGenerator.trigger("didInitOrChange", currentMedia);
          config.$eventGenerator.trigger("didChange", currentMedia);
          oldCurrentMedia = currentMedia;
        }
      }

      var getCurrentMedia = (api.getCurrentMedia = function () {
        var currentMediaObject = {};
        config.media.forEach(function (media) {
          if (!media.$el) {
            throw new Error("$el is undefined");
          }

          currentMediaObject[media.mediaProperty] = getCurrentMediaFromElement(
            media.$el,
            media.pseudoEl,
            media.mediaRegexes
          );
        });

        return currentMediaObject;
      });

      api.off = function () {
        config.$eventGenerator.off.apply(config.$eventGenerator, arguments);
        return api;
      };

      api.on = function (eventName, handler) {
        config.$eventGenerator.on.apply(config.$eventGenerator, arguments);
        if (inited && (eventName === "didInit" || eventName === "didInitOrChange")) {
          handler(new $.Event(eventName), getCurrentMedia());
        }

        return api;
      };

      inited = false;

      config = {
        $eventGenerator: angular.element(api),
        media: [defaultMedia],
      };

      if (overrides instanceof Array) {
        config.media = overrides;
      } else {
        config.media = [overrides];
      }

      config.media = config.media.map(function (media) {
        return Object.assign({}, defaultMedia, media);
      });

      config.media.forEach(function (media) {
        if (!media.$el.length) {
          throw new Error(`No $el found for media "${media.mediaProperty}". Did you specify one?`);
        }
      });

      config.$eventGenerator.trigger("willInit");

      currentMedia = getCurrentMedia();
      oldCurrentMedia = currentMedia;
      window.addEventListener("resize", triggerEventIfMediaChanged);

      config.$eventGenerator.trigger("didInitOrChange", currentMedia);
      config.$eventGenerator.trigger("didInit", currentMedia);

      inited = true;

      return api;
    };
  });
})(window.angular);
